import useMessageService from 'api/services/messageService'
import Loading from 'components/common/loading/Loading'
import MessagesModal from 'components/messages/MessagesModal'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'

const MessagesPage = () => {
  const navigate = useNavigate()

  const { loadMessages } = useMessageService()
  const { data: messages, isLoading } = useQuery('messages', loadMessages)

  const handleClose = () => navigate('/')

  if (!messages || isLoading) return <Loading />
  return (
    <MessagesModal
      isOpen
      isLoading={isLoading}
      messages={messages as any}
      handleClose={handleClose}
    />
  )
}

export default MessagesPage
